import { useEffect, useRef } from 'react'

// What identifies a series across a redraw: whatever the builder named it by, and its label
// otherwise. Never its place in the chart -- that is exactly what a sort changes.
const identityOf = series => series.options?.id ?? series.name

// A reader hides a series from the legend, then sorts the table. Only the chart's data is updated
// in place on a sort, and Highcharts carries each series' visibility across that update by INDEX,
// so the hidden slot lands on whichever answer was sorted into it. The hidden set is a property of
// the answer, so it is read off the chart before the update and put back by identity after it.
//
// A chart-mode switch builds a new chart, and nothing carries over to it.
export const useLegendVisibility = ({ chartRef, chartMode }) => {
  const hiddenRef = useRef(null)
  const builtModeRef = useRef(chartMode)

  const chart = chartRef.current?.chart

  hiddenRef.current =
    chart && builtModeRef.current === chartMode
      ? new Set(chart.series.filter(series => false === series.visible).map(identityOf))
      : null

  useEffect(() => {
    const chart = chartRef.current?.chart
    const hidden = hiddenRef.current

    builtModeRef.current = chartMode
    if (!chart || !hidden?.size) return

    const restored = chart.series.filter(series => hidden.has(identityOf(series)) !== (false === series.visible))
    if (!restored.length) return

    restored.forEach(series => series.setVisible(!hidden.has(identityOf(series)), false))
    chart.redraw()
  })
}
